var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05141 21.7559C8.00065 21.9117 7.99565 22.0788 8.03699 22.2375C8.07833 22.3961 8.16429 22.5395 8.28466 22.6507C8.40503 22.762 8.55478 22.8364 8.71615 22.8651C8.87752 22.8939 9.04375 22.8757 9.19513 22.8129L27.8796 15.0743C28.037 15.0089 28.1713 14.8981 28.2654 14.7559C28.3595 14.6138 28.4091 14.4468 28.4078 14.2764C28.4066 14.1059 28.3545 13.9397 28.2583 13.799C28.1621 13.6583 28.0261 13.5494 27.8677 13.4864L9.07131 6.02823C8.91901 5.96763 8.75253 5.95197 8.59161 5.98311C8.43068 6.01425 8.28206 6.09087 8.16336 6.2039C8.04465 6.31693 7.96085 6.46163 7.92187 6.62083C7.8829 6.78004 7.89039 6.94709 7.94346 7.10217L10.3476 14.1394C10.4084 14.3154 10.4103 14.5064 10.3528 14.6836L8.05383 21.7558L8.05141 21.7559Z",
    stroke: "#9AA0A6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0176 14.5972L10.5176 16.3292L10.5176 12.8651L18.0176 14.5972Z",
    fill: "#9AA0A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveSendMessage);
export default __webpack_public_path__ + "static/media/inactiveSendMessage.85ae800f043e2d26d27919bc6f26e554.svg";
export { ForwardRef as ReactComponent };